import { isObject, isValidString } from '../utils/typeGuards';

export type IMediaType = 'image' | 'video' | 'json' | 'pdf' | string;

// this is the payload upload base type
export type IMediaInfo = {
  id: string;
  alt?: string;
  filename: string;
  mimeType: string;
  filesize: number;
  focalX?: number;
  focalY?: number;
  // sizes?: Record<string, { url: string | null }>;
  createdAt: Date | string;
  updatedAt?: Date | string;
  url: string;
};

// !!! todo remap payloadcms media
export type IMedia = Record<string, unknown> & Partial<IMediaInfo> & {
  title?: string;
  abstract?: string;
  type: IMediaType;
  src?: string;
  media?: IMedia;
  width?: string | number;
  height?: string | number;
};

export type IMediaImage = Omit<IMedia, 'type'> & {
  type: 'image';
};

export type IMediaVideo = Omit<IMedia, 'type'> & {
  type: 'video';
};

export type IMediaJson = Omit<IMedia, 'type'> & {
  type: 'json';
};

export type IMediaPdf = Omit<IMedia, 'type'> & {
  type: 'pdf';
};

export function resolveMediaType(media: { type?: string, mimeType?: string }): IMediaType {
  if (typeof media.type === 'string' && media.type.length > 0) {
    return media.type;
  }
  if (typeof media.mimeType === 'string' && media.mimeType.length > 0) {
    const mime = media.mimeType.split('/');
    return mime[0] === 'application' ? mime[1]! : mime[0]!;
  }
  return 'unknown';
}

export function isMediaImage(media: { type?: string, mimeType?: string }): media is IMediaImage {
  const type = resolveMediaType(media);
  if (type === 'image') {
    media.type = type;
    return true;
  }
  return false;
}

export function isMediaVideo(media: { type?: string, mimeType?: string }): media is IMediaVideo {
  const type = resolveMediaType(media);
  if (type === 'video') {
    media.type = type;
    return true;
  }
  return false;
}

export function isMediaJson(media: { type?: string, mimeType?: string }): media is IMediaJson {
  const type = resolveMediaType(media);
  if (type === 'json') {
    media.type = type;
    return true;
  }
  return false;
}

export function isMediaPdf(media: { type?: string, mimeType?: string }): media is IMediaPdf {
  const type = resolveMediaType(media);
  if (type === 'pdf') {
    media.type = type;
    return true;
  }
  return false;
}

export function isMedia(item: unknown): item is IMedia {
  return isObject(item) &&
    ('mimeType' in item || 'type' in item) &&
    (isValidString(item.url) || isValidString(item.src));
}
